import React from 'react';
import CouponPreview from '../../common/CouponPreview';
import CouponBrandLinkInfo from '../../common/CouponBrandLinkInfo';

const CouponSaveBrandLinkInfo = (props) => {
  const {
    couponInfo,
    couponBrandLinkInfo,
    getCouponBrandItemList,
    getCouponBrandItemListExcelDownload,
    getSelectedCouponBrandItemListExcelDownload,
    checkValidCouponBrandItemListExcelUpload,
    selectCouponBrandItemList,
    toggleModal,
  } = props;

  return (
    <div className="coupon-save-brand-link-info">
      {/*쿠폰 미리보기*/}
      <CouponPreview couponInfo={couponInfo} />

      {/*쿠폰 사용 가능한 브랜드*/}
      <CouponBrandLinkInfo
        minimumPurchasePrice={couponInfo.minimumPurchasePrice}
        discountAmount={couponInfo.discountAmount}
        discountType={couponInfo.discountType}
        maxDiscountPrice={couponInfo.maxDiscountPrice}
        exclude24k={couponInfo.exclude24k}
        couponBrandLinkInfo={couponBrandLinkInfo}
        getCouponBrandItemList={getCouponBrandItemList}
        getCouponBrandItemListExcelDownload={getCouponBrandItemListExcelDownload}
        getSelectedCouponBrandItemListExcelDownload={getSelectedCouponBrandItemListExcelDownload}
        checkValidCouponBrandItemListExcelUpload={checkValidCouponBrandItemListExcelUpload}
        selectCouponBrandItemList={selectCouponBrandItemList}
        toggleModal={toggleModal}
      />
    </div>
  );
};

export default CouponSaveBrandLinkInfo;
